import { useTranslation } from 'react-i18next'

import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { LogaltyPending } from '@/Logalty/ui/molecules'

export const Step4Pending = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <LogaltyPending
      description={t(
        contractTranslation.changeBankAccount.step4.status.checking.description,
      )}
    />
  )
}
